import { Box, Button, Flex } from '@amzn/ring-ui-react-components';
import { useTranslation } from 'react-i18next';
import { Icon } from 'src/shared/components/Icon';

export interface VideoPlayerHeaderProps {
  device: string;
  handleChangeCamerasClick: () => void;
  handleChangeLocationClick: () => void;
  hasLocationSelector: boolean;
  isMobile: boolean;
  location: string;
  previewDeviceName: string;
}

export const VideoPlayerHeader = ({
  device,
  handleChangeCamerasClick,
  handleChangeLocationClick,
  hasLocationSelector,
  isMobile,
  location,
  previewDeviceName,
}: VideoPlayerHeaderProps) => {
  const { t } = useTranslation('components.posting');
  if (isMobile) {
    return (
      <>
        {hasLocationSelector && (
          <Flex
            flexDirection="row"
            justifyContent="space-between"
            borderColor="tertiary.500"
            borderStyle="solid"
            borderTopWidth={1}
            px={6}
            py={4}
          >
            <Box color="neutral.300" textStyle="body-normal-medium">
              {location}
            </Box>
            <Box>
              <Button
                color="primary.400"
                textStyle="body-normal-medium"
                variant="link"
                w="auto"
                onClick={handleChangeLocationClick}
              >
                {t('change-location')}
              </Button>
            </Box>
          </Flex>
        )}
        <Flex
          flexDirection="row"
          justifyContent="space-between"
          borderColor="tertiary.500"
          borderStyle="solid"
          borderTopWidth={1}
          px={6}
          py={4}
        >
          <Box color="neutral.300" textStyle="body-normal-medium">
            {device}
          </Box>
          <Box>
            <Button
              color="primary.400"
              textStyle="body-normal-medium"
              variant="link"
              w="auto"
              onClick={handleChangeCamerasClick}
            >
              {t('change-cameras')}
            </Button>
          </Box>
        </Flex>
      </>
    );
  }

  return (
    <Flex
      flexDirection="row"
      borderColor="tertiary.500"
      borderStyle="solid"
      borderWidth={1}
      borderTopLeftRadius="medium"
      borderTopRightRadius="medium"
      mt={8}
      pl={5}
      py={3}
    >
      <Box>
        <Icon name="camera" mr={3} size={24} />
      </Box>
      <Box color="neutral.500" textStyle="body-large-medium">
        {previewDeviceName}
      </Box>
    </Flex>
  );
};
